import {
    combineSlices,
    configureStore,
    type ConfigureStoreOptions,
    type ThunkAction,
    type UnknownAction,
} from '@reduxjs/toolkit';
import { type TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';

import { oopsApi } from 'store/api/oopsApi';
import { referenceApi } from 'store/api/referenceApi';
import { authSlice } from 'store/auth/authSlice';

const slices = [authSlice];

const apiSlices = [oopsApi, referenceApi];

const rootReducer = combineSlices(...slices, ...apiSlices);

export const store = configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({ serializableCheck: false }).concat(
            apiSlices.map((slice) => slice.middleware),
        ),
    enhancers: (getDefaultEnhancers) => getDefaultEnhancers(),
    devTools: process.env.REACT_APP_ENV !== 'prd',
});

export type AppDispatch = typeof store.dispatch;
export const useAppDispatch: () => AppDispatch = useDispatch;

export type RootState = ReturnType<typeof store.getState>;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

export type AppThunk<ReturnType = void> = ThunkAction<
    ReturnType,
    RootState,
    unknown,
    UnknownAction
>;

/** Used for configuration of redux store in tests */
export const MockStore: ConfigureStoreOptions = {
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({ serializableCheck: false }).concat(
            apiSlices.map((slice) => slice.middleware),
        ),
};
